import {
  GetDashboardByTokenDocument,
  useDeleteScheduleMutation,
} from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import { useGetUser } from 'v2/core/services/user';

interface DeleteScheduleReportSubscriptionOptions {
  token: string;
  shouldRefetchQueries?: boolean;
}

export const useDeleteScheduleReportSubscription = ({
  token,
  shouldRefetchQueries,
}: DeleteScheduleReportSubscriptionOptions) => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const [deleteScheduleMutation, { loading: isLoading }] =
    useDeleteScheduleMutation();

  const deleteScheduleReport = async (scheduleID: UUID) => {
    if (!token) {
      return;
    }

    await deleteScheduleMutation({
      variables: {
        tenantID,
        id: scheduleID,
      },
      refetchQueries: shouldRefetchQueries
        ? [
            {
              query: GetDashboardByTokenDocument,
              variables: {
                token,
                userID,
                tenantID: tenantID,
                includeScheduleOutbounds: true,
              },
            },
          ]
        : undefined,
    });
  };

  return {
    deleteScheduleReport,
    isLoading,
  };
};
